export default __webpack_public_path__ + "static/media/user.35abfdcc.jpg";